import { TmcContextService } from './../../../../../../common/tmc-context.service';
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Station } from '../../../../../../client/model/station';
import { StationSet } from '../../../../../../client/model/station-set';
import { StationType } from '../../../../../../client/model/station-type.enum';

import { SacClientContext } from '../../../model/sac-client.context';
import { SacClientService } from '../../../service/sac-client.service';
import { SuspendStationDialogComponent, SuspendStationDialogData } from '../sac-working-area/suspend-station-dialog/suspend-station-dialog.component';
import { DialogService } from '@sdbn/common';


@Component({
  selector: 'app-sac-station-item',
  templateUrl: './sac-station-item.component.html',
  styleUrls: ['./sac-station-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SacStationItemComponent implements OnInit, OnDestroy {

  latsUpdated: number;

  stationType = StationType;

  sacClientContext: SacClientContext;

  @Input() station: Station;
  @Input() stationSet: StationSet;
  @Input() selected: boolean = false;

  selectionSubscription: Subscription;

  style = 'default';
  background = 'none';

  @Input('sacClientContext') set setSacClientContext(sacClientContext: SacClientContext) {
    this.sacClientContext = sacClientContext;
    if (this.selectionSubscription != null) {
      this.selectionSubscription.unsubscribe();
    }


  }

  constructor(
    private dialog: MatDialog,
    private tmcContextService: TmcContextService,
    private sacClientService: SacClientService,
    private dialogService: DialogService
  ) { }

  ngOnDestroy(): void {
    if (this.selectionSubscription != null) {
      this.selectionSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
  }

  public startSuspension() {
    const dialogData: SuspendStationDialogData = {
      stattionId: this.station.id
    };

    this.dialog.open(SuspendStationDialogComponent, {
      data: dialogData,
    }).afterClosed().subscribe(
      () => this.tmcContextService.forceRefreshOfStationUsages()
    );
  }

  public endSuspension() {

    this.dialogService.showConfirm(
      'tmc-yard.ui.control.sac-client.confirm.end-suspension.title',
      'tmc-yard.ui.control.sac-client.confirm.end-suspension.message'
    ).afterClosed().subscribe(result => {
      this.tmcContextService.forceRefreshOfStationUsages();
    }, error => {
      console.error('Error while ending station suspension', error);
      this.tmcContextService.forceRefreshOfStationUsages();
    });

  }

}
